import { mocks } from '@seek/ca-graphql-client';

import {
  languageProficiencies,
  personalDetails,
  summary,
} from '../test/shareableProfileTestData';
import {
  profileInsightsWithActivities,
  profileInsightsWithoutActivities,
  profileSuggestionsWithData,
  shareableProfileVerifiedIdentities,
  verificationsComplete,
  verificationsEmpty,
  verificationsEmptyVerified,
} from '../test/test-data';

const randomInt1To10 = () => Math.floor(Math.random() * 10) + 1;

const profileSettings = [
  {
    active: true,
    profileSlug: 'fred-smith-abcd1234',
    url: 'https://www.seek.com.au/profile/fred-smith-abcd1234',
    displayUrl: 'seek.com.au/profile/fred-smith-abcd1234',
    views: 5,
  },
  {
    active: null,
    profileSlug: null,
    url: null,
    views: null,
  },
  {
    active: false,
    profileSlug: 'fred-smith-abcd1234',
    url: 'https://www.seek.com.au/profile/fred-smith-abcd1234',
    displayUrl: 'seek.com.au/profile/fred-smith-abcd1234',
    views: 5,
  },
];

const shareableProfileSettings = () => {
  const zeroToTwo = randomInt1To10() % 3;
  return profileSettings[zeroToTwo];
};

const shareableProfileVerifiedIdentity = () => {
  const zeroToTwo = randomInt1To10() % 3;
  return shareableProfileVerifiedIdentities[zeroToTwo];
};

const profileInsights = () => {
  const zeroToTwo = randomInt1To10() % 3;
  const profileInsightsPossibleData = [
    null,
    profileInsightsWithoutActivities,
    profileInsightsWithActivities,
  ];
  return profileInsightsPossibleData[zeroToTwo];
};

const profileSuggestions = () => profileSuggestionsWithData;

const profileVerifications = () => {
  const zeroToThree = randomInt1To10() % 4;
  const verificationsPossibleData = [
    null,
    verificationsComplete,
    verificationsEmpty,
    verificationsEmptyVerified,
  ];
  return verificationsPossibleData[zeroToThree];
};

export const mockOverrides = {
  DocumentDownloadLink: {
    link: 'http://localhost:3000/profile/resumes/download/1234',
  },
  Candidate: () => ({
    // eslint-disable-next-line new-cap
    ...mocks.Candidate(),

    shareableProfileSettings: () => shareableProfileSettings(),
    profileInsights: () => profileInsights(),
    profileSuggestions: () => profileSuggestions(),
    profileVerifications: () => profileVerifications(),
  }),
  ShareableProfile: () => ({
    active: randomInt1To10() >= 2,
    // Only need custom mocks for these ones as they resolve to field names rather than types
    personalDetails: personalDetails(),
    summary: summary(),
    languageProficiencies: languageProficiencies(),
    verifiedIdentity: shareableProfileVerifiedIdentity(),
  }),
};
